import {
  GET_ROLESANDPERMISSIONS,
  GET_SUPPLIERROLE,
} from 'resources/actionTypes';

export function fetchRolesAndPermissions(authRole) {
  return {
    type: GET_ROLESANDPERMISSIONS.GET_ROLESANDPERMISSIONS_REQUESTED,
    payload: authRole || '',
  };
}

export function fetchSupplierRole(data) {
  return {
    type: GET_SUPPLIERROLE.GET_SUPPLIERROLE_REQUESTED,
    payload: data,
  };
}
